import type { I18nFn } from 'i18n/types/I18nFn';

import type { ListingRteAtsWarningType } from './types/ListingRteAtsWarningType';

export const LISTING_RTE_ATS_WARNINGS = (i18n: I18nFn) =>
  ({
    EMAIL: i18n(
      `Did you mean to include an email address? Idealist won’t be able to track applicants who email you directly.`,
    ),
    URL: i18n(
      `Did you mean to include a URL? Idealist won’t be able to track applicants who apply off-site.`,
    ),
    BOTH: i18n(
      `Did you mean to include an email address or URL? Idealist won’t be able to track applicants who email you directly or apply off-site.`,
    ),
  }) satisfies Record<ListingRteAtsWarningType, string>;
